const PRINTER_SET = 'PRINTER/SET';

export default function printerSetAction(printer: string | null) {
  return {
    type: PRINTER_SET,
    payload: {
      printer: printer,
    },
  };
}

export { PRINTER_SET };
